//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
// import RoleBox from '@/components/RoleBox';

export default {
  //   components: {
  //     RoleBox,
  //   },
  data() {
    return {
      operation: 'create',
      listData: [],
      count: 0,
      formObj: {},
      appOptions: [],
      oldSearchObj: {},
      searchObj: {
        keyword: this.$route.query.keyword || '',
        appid: Number(this.$route.query.appid) || 0,
        page: Number(this.$route.query.page) || 1,
        page_size: Number(this.$route.query.page_size) || 10,
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入接口名称',
            trigger: 'blur',
          },
        ],
        appid: [
          {
            required: true,
            message: '请选择应用名称',
            trigger: 'blur',
          },
        ],
        path: [
          {
            required: true,
            message: '请输入接口路径',
            trigger: 'blur',
          },
        ],
      },
      opDialogVisible: false,
      roleDialogVisible: false,
      submitDisable: false,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    jurisdiction() {
      return {
        apiManage: this.getElementList.includes('api-manage'),
      };
    },
  },
  async mounted() {
    if (!this.searchObj.appid) {
      this.searchObj.appid = Number(sessionStorage.getItem('app_id'));
    } else {
      sessionStorage.setItem('app_id', this.searchObj.appid);
    }
    await this.loadAppOption();
    if (this.searchObj.appid) {
      this.loadListData();
    }
  },
  methods: {
    searchList() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.oldSearchObj.page && this.oldSearchObj.page === this.searchObj.page) {
        this.searchObj.page = 1;
      }
      this.oldSearchObj = Object.assign({}, this.searchObj);
      this.timer = setTimeout(() => {
        this.$router.push({ query: this.searchObj });
        sessionStorage.setItem('app_id', this.searchObj.appid);
        this.loadListData();
      }, 300);
    },
    resetForm() {
      this.searchObj.keyword = '';
      this.searchList();
    },
    loadListData() {
      const url = this.$api.getApiList;
      const data = this.searchObj;
      const cb = (data) => {
        this.count = data.total;
        this.listData = data.data;
      };
      this.$request({ url, data, cb });
    },
    async loadAppOption() {
      const url = this.$api.getAppList;
      const data = { page_size: 999999 };
      const res = await this.$request({ url, data });
      this.appOptions = res.data;
      this.searchObj.appid = this.searchObj.appid || this.appOptions[0].id;
    },
    submitForm() {
      if (this.submitDisable) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.opDialogVisible = false;
        this.submitDisable = true;
        const { id } = this.formObj;
        const url = id ? this.$api.updateApi : this.$api.createApi;
        const msg = id ? '修改成功' : '创建成功';
        let data = Object.assign({}, this.formObj);
        if (id) {
          data = {
            id,
            name: this.formObj.name,
            path: this.formObj.path,
            description: this.formObj.description,
          };
        }
        this.submitDisable = false;
        const cb = () => {
          this.$message({
            message: msg,
            type: 'success',
          });
          this.loadListData();
        };
        const type = 'post';
        this.$request({ url, data, cb, type });
      });
    },
    deleteOperation(id) {
      const url = this.$api.deleteApi;
      const type = 'post';
      const cb = () => {
        this.$message({
          message: '删除成功',
          type: 'success',
        });
        this.loadListData();
      };
      this.$request({ url, cb, type, data: { id } });
    },
    handleAdd() {
      this.operation = 'create';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = {
        appid: this.searchObj.appid,
      };
      this.opDialogVisible = true;
    },
    handleEdit(index, data) {
      this.operation = 'update';
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
      this.formObj = Object.assign({}, data);
      this.opDialogVisible = true;
    },
    handleDelete(index, data) {
      this.$confirm('是否删除该接口?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteOperation(data.id);
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    handleCurrentChange(val) {
      this.searchObj.page = val;
      this.searchList();
    },
    handleSizeChange(val) {
      this.searchObj.page = 1;
      this.searchObj.page_size = val;
      this.searchList();
    },
  },
};
